// @ts-nocheck
import React from 'react';
import WorkflowPage from './WorkflowPageFactory';
import { TransactionInfo } from '../workflow/transaction/TransactionDetails';

export default function TransactionPage() {
  return (
    <WorkflowPage stepId="transaction">
      {({ data, setData, navigateTo }) => (
        <TransactionInfo formData={data} setFormData={setData} setActiveTab={navigateTo} />
      )}
    </WorkflowPage>
  );
}
